import react, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Puff } from "react-loading-icons";
import NavBar from "../../../../components/NavBar.jsx";

import "./FormNightspot.css";

import NightspotRequests from "../NightspotRequests.js";

//Steps
import Details from "./Details/Details";
import Location from "./Location/Location";
import Gallery from "./Gallery/Gallery";
import Finish from "./Finish/Finish";

const FormNightspot = () => {
  let params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  // const pathname = location.pathname;

  const [isLoading, setIsLoading] = useState(false);

  const [form, setForm] = useState({
    id: 0,
    validation: [],
    details: {
      name: "",
      type: location.state ? location.state.type : "",
      phone_country: "",
      phone_number: "",
      description: "",
      id_venues_type: "",
      link_instagram: "",
      link_facebook: "",
      ids_venues_genres: [],
      schedule: {
        monday: {
          start: "",
          end: "",
          isClosed: 0,
        },
        tuesday: {
          start: "",
          end: "",
          isClosed: 0,
        },
        wednesday: {
          start: "",
          end: "",
          isClosed: 0,
        },
        thursday: {
          start: "",
          end: "",
          isClosed: 0,
        },
        friday: {
          start: "",
          end: "",
          isClosed: 0,
        },
        saturday: {
          start: "",
          end: "",
          isClosed: 0,
        },
        sunday: {
          start: "",
          end: "",
          isClosed: 0,
        },
      },
    },
    location: {
      address_components: [],
      formatted_address: "",
      geometry: {
        lng: "",
        lat: "",
      },
      place_id: "",
    },
    gallery: {
      list: [],
    },
    errors: [],
  });
  useEffect(async () => {
    document.title = "Nightspot | Nightspot Dashboard";
    setIsLoading(true);
    let info = await NightspotRequests.getInfoFormNightspot(params);
    if (info && info.status) {
      setForm((prevForm) => ({
        ...prevForm,
        ...info.data,
        details: {
          ...info.data.details,
          type: prevForm.details.type
            ? prevForm.details.type
            : info.data.details.type,
        },
      }));
    }
    setIsLoading(false);
  }, []);

  // handler inputs
  const handleChangeInputs = (e, key) => {
    setForm({
      ...form,
      [key]: e,
    });
  };

  const handlerPagination = (action) => {
    let response = null;
    //let id = 0;
    let tab = location.hash.substring(1);
    tab = location.hash === "" ? "details" : tab;
    if (action === "next") {
      switch (tab) {
        case "details":
          response = saveHandler(action, tab);
          break;
        case "location":
          response = saveHandler(action, tab);
          //navigate(`${location.pathname}#gallery`);
          break;
        case "gallery":
          response = saveHandler(action, tab);

          //navigate(`${location.pathname}#finish`);
          break;

        default:
          break;
      }
    } else if (action === "prev") {
      switch (tab) {
        case "location":
          response = saveHandler(action, tab);
          navigate(`${location.pathname}#details`);
          break;
        case "gallery":
          response = saveHandler(action, tab);
          if (form.details.type === "organization") {
            navigate(`${location.pathname}#details`);
          } else {
            navigate(`${location.pathname}#location`);
          }
          break;
        case "finish":
          response = saveHandler(action, tab);
          navigate(`${location.pathname}#gallery`);
          break;

        default:
          break;
      }
    }
  };

  const handlerProgressTabs = (pageParam) => {
    let tab = location.hash.substring(1);
    tab = location.hash === "" ? "details" : tab;
    let arr = {
      1: "details",
      2: "location",
      3: "gallery",
      4: "finish",
    };
    let page = Object.keys(arr).find((key) => arr[key] === tab);
    let pageSelected = Object.keys(arr).find((key) => arr[key] === pageParam);
    if (pageSelected <= page) {
      return true;
    }
    return false;
  };

  const saveHandler = async (action, tab) => {
    setIsLoading(true);
    let response = await NightspotRequests.postFormNightspot(
      form,
      action,
      tab,
      params,
    );
    if (response && response.status === true) {
      setForm({
        ...form,
        id: response.data.id,
        validation: response.autoInspect ? response.autoInspect : [],
        plan_id: response.plan_id,
      });

      let validateGaleryTypeFilled = true;
      form.gallery.list.map((item) => {
        if (item.type === "Select option") {
          validateGaleryTypeFilled = false;
        }
      });

      if (action === "next") {
        switch (tab) {
          case "details":
            if (form.details.type === "organization") {
              navigate(`${location.pathname}#gallery`);
            } else {
              navigate(`/my/nightspots/update/${response.data.id}/#location`);
            }
            break;
          case "location":
            navigate(`${location.pathname}#gallery`);
            break;
          case "gallery":
            if (!validateGaleryTypeFilled) {
              setIsLoading(false);
              return false;
            }
            navigate(`${location.pathname}#finish`);
            break;

          default:
            break;
        }
      } else if (action === "prev") {
        switch (tab) {
          case "location":
            navigate(`${location.pathname}#details`);
            break;
        }
      }
      setIsLoading(false);
      return response;
    } else {
      setForm({
        ...form,
        errors: response.errors,
      });
    }
    setIsLoading(false);
    return false;
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-12 ">
                    <h2 className="dashboard-h2">
                      Preencha os campos em baixo sobre o seu{" "}
                      <span>Nightspot</span>{" "}
                    </h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <ul id="progressbar">
                      <li
                        style={
                          form.details.type === "organization"
                            ? { width: "33.333%" }
                            : {}
                        }
                        className={
                          handlerProgressTabs("details") ? `active ` : ``
                        }
                        id="home"
                        onClick={() => saveHandler("prev", "location")}
                      >
                        <strong>Detalhes</strong>
                      </li>
                      {form.details.type === "venue" && (
                        <li
                          className={
                            handlerProgressTabs("location") ? `active` : ``
                          }
                          id="location"
                          onClick={() => saveHandler("next", "details")}
                        >
                          <strong>Localização</strong>
                        </li>
                      )}

                      <li
                        className={
                          handlerProgressTabs("gallery") ? `active` : ``
                        }
                        style={
                          form.details.type === "organization"
                            ? { width: "33.333%" }
                            : {}
                        }
                        id="images"
                        onClick={() => saveHandler("next", "location")}
                      >
                        <strong>Galeria</strong>
                      </li>

                      {/* <li id="payment"><strong>Payment</strong></li> */}
                      <li
                        style={
                          form.details.type === "organization"
                            ? { width: "33.333%" }
                            : {}
                        }
                        className={
                          handlerProgressTabs("finish") ? `active` : ``
                        }
                        id="confirm"
                        onClick={() => saveHandler("next", "gallery")}
                      >
                        <strong>Fim</strong>
                      </li>
                    </ul>
                  </div>
                </div>

                <Details
                  type={form.details.type}
                  visible={
                    location.hash.substring(1) === "details" ||
                      location.hash.substring(1) === ""
                      ? true
                      : false
                  }
                  handleChangeForm={(form) =>
                    handleChangeInputs(form, "details")
                  }
                  form={form}
                  generalInfo={form.general}
                  isLoading={isLoading}
                />
                <Location
                  visible={
                    location.hash.substring(1) === "location" ? true : false
                  }
                  handleChangeForm={(form) =>
                    handleChangeInputs(form, "location")
                  }
                  form={form.location}
                />
                <Gallery
                  visible={
                    location.hash.substring(1) === "gallery" ? true : false
                  }
                  handleChangeForm={(form) =>
                    handleChangeInputs(form, "gallery")
                  }
                  form={form.gallery}
                  formGeneral={form}
                  showLoading={() => setIsLoading(true)}
                  hideLoading={() => setIsLoading(false)}
                />
                <Finish
                  visible={
                    location.hash.substring(1) === "finish" ? true : false
                  }
                  form={form.validation}
                  plan_id={form.plan_id}
                />

                <div className="row" style={{ marginTop: "50px" }}>
                  <div className="col">&nbsp;</div>
                  <div
                    className="col-5 col-sm-2 text-center"
                    style={{
                      display:
                        location.hash.substring(1) === "details" ||
                          location.hash.substring(1) === ""
                          ? "none"
                          : "block",
                    }}
                  >
                    <div
                      className="btn-pagination left"
                      onClick={() => handlerPagination("prev")}
                    >
                      <i
                        style={{ color: "#192025" }}
                        className="fa-solid fa-chevron-left"
                      ></i>
                      &nbsp;PASSO ANTERIOR
                    </div>
                  </div>
                  <div
                    className="col-5 col-sm-2 text-center"
                    style={{
                      display:
                        location.hash.substring(1) === "finish"
                          ? "none"
                          : "block",
                    }}
                  >
                    <div
                      className="btn-pagination right"
                      onClick={() => handlerPagination("next")}
                    >
                      PRÓXIMO PASSO&nbsp;
                      <i
                        style={{ color: "#192025" }}
                        className="fa-solid fa-chevron-right"
                      ></i>
                    </div>
                  </div>
                  <div
                    className="col-5 col-sm-3 text-center"
                    style={{
                      display:
                        location.hash.substring(1) === "finish"
                          ? "block"
                          : "none",
                    }}
                  >
                    <div
                      className="btn-pagination"
                      onClick={() => navigate(`/my/nightspots`)}
                    >
                      <i
                        style={{ color: "#192025" }}
                        className="fa-solid fa-home"
                      ></i>
                      &nbsp;IR PARA A PÁGINA INICIAL
                    </div>
                  </div>
                  <div className="col">&nbsp;</div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default FormNightspot;
